const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';
const ERROR_LOG_URL = `${API_BASE_URL}/api/error-logs/client`;

let handlersInstalled = false;

function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || 'null');
  } catch {
    return null;
  }
}

function parseUserAgent(userAgent = navigator.userAgent || '') {
  return {
    browser:
      /Edg\//.test(userAgent) ? 'Edge' :
      /Chrome\//.test(userAgent) && !/Edg\//.test(userAgent) ? 'Chrome' :
      /Firefox\//.test(userAgent) ? 'Firefox' :
      /Safari\//.test(userAgent) && !/Chrome\//.test(userAgent) ? 'Safari' :
      /OPR\//.test(userAgent) ? 'Opera' :
      'Unknown',
    os:
      /Windows/i.test(userAgent) ? 'Windows' :
      /iPhone|iPad|iPod/i.test(userAgent) ? 'iOS' :
      /Android/i.test(userAgent) ? 'Android' :
      /Mac OS X/i.test(userAgent) ? 'macOS' :
      /Linux/i.test(userAgent) ? 'Linux' :
      'Unknown',
    device: /iPad/i.test(userAgent) ? 'Tablet' : /Mobile|iPhone|Android/i.test(userAgent) ? 'Mobile' : 'Desktop',
  };
}

function serializeError(error) {
  if (!error) {
    return { message: 'Unknown error' };
  }
  if (typeof error === 'string') {
    return { message: error };
  }
  return {
    message: error.message || 'Unknown error',
    name: error.name || 'Error',
    stack: error.stack || '',
  };
}

function reportClientError(payload) {
  try {
    const userInfo = getUserInfo();
    const userAgent = navigator.userAgent || '';
    const parsed = parseUserAgent(userAgent);
    const body = JSON.stringify({
      level: payload.level || 'error',
      message: payload.message || 'Client error',
      name: payload.name || 'Error',
      stack: payload.stack || '',
      statusCode: payload.statusCode,
      path: payload.path || window.location.pathname,
      route: payload.route || window.location.pathname,
      url: payload.url || window.location.href,
      origin: window.location.origin,
      referer: document.referrer || '',
      userAgent,
      browser: payload.browser || parsed.browser,
      os: payload.os || parsed.os,
      device: payload.device || parsed.device,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      userId: payload.userId || userInfo?._id,
      userEmail: payload.userEmail || userInfo?.email,
      requestId: payload.requestId,
      query: payload.query,
      bodyPreview: payload.bodyPreview,
      errorDetails: payload.errorDetails,
      metadata: payload.metadata,
    });

    fetch(ERROR_LOG_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'include',
    }).catch(() => {});
  } catch {
    // Swallow client-side logging failures.
  }
}

function installGlobalErrorHandlers() {
  if (handlersInstalled) return;
  handlersInstalled = true;

  window.addEventListener('error', (event) => {
    const error = serializeError(event.error || event.message);
    reportClientError({
      ...error,
      metadata: {
        kind: 'window.error',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const error = serializeError(event.reason);
    reportClientError({
      ...error,
      metadata: {
        kind: 'unhandledrejection',
      },
      errorDetails: typeof event.reason === 'object' ? event.reason : { value: String(event.reason) },
    });
  });
}

export { installGlobalErrorHandlers, reportClientError, serializeError };
